import {
    NatGetAdminBulletinBoardThreadList,
    SearchCondition as AdminBulletinBoardThreadListSearchCondition,
    SearchConditionPageInfo as AdminBulletinBoardThreadListSearchConditionPageInfo
} from './NatGetAdminBulletinBoardThreadList'
import {
    NatGetResidentBulletinBoardThreadList,
    SearchCondition as ResidentBulletinBoardThreadListSearchCondition,
} from './NatGetResidentBulletinBoardThreadList'
import {NatGetResidentBulletinBoardThread} from './NatGetResidentBulletinBoardThread'
import {NatGetResidentBulletinBoardThreadCommentList,} from './NatGetResidentBulletinBoardThreadCommentList';
import Http from '../../../../network/Http'
import {SortOrder} from '../../../../components/shared/SortOrder';
import {NatGetAdminBulletinBoardThread} from './NatGetAdminBulletinBoardThread';
import {NatGetAdminBulletinBoardThreadCommentList,} from './NatGetAdminBulletinBoardThreadCommentList';
import {NatGetAdminBulletinBoardThreadComment,} from './NatGetAdminBulletinBoardThreadComment';
import {NatPostBulletinBoardThreadRead} from './NatPostBulletinBoardThreadRead'
import {NatPostBulletinBoardThread, NatPostBulletinBoardThreadParams} from './NatPostBulletinBoardThread'
import {
    NatPostBulletinBoardThreadConfirm,
    NatPostBulletinBoardThreadConfirmParams
} from './NatPostBulletinBoardThreadConfirm'
import {
    NatPostBulletinBoardThreadCommentConfirm,
    NatPostBulletinBoardThreadCommentConfirmParams
} from './NatPostBulletinBoardThreadCommentConfirm'
import {NatPostBulletinBoardThreadSession} from './NatPostBulletinBoardThreadSession'
import {
    NatPostBulletinBoardThreadComment,
    NatPostBulletinBoardThreadCommentParams
} from './NatPostBulletinBoardThreadComment'
import {NatPutBulletinBoardThread, NatPutBulletinBoardThreadParams} from './NatPutBulletinBoardThread'
import {
    NatPutBulletinBoardThreadComment,
    NatPutBulletinBoardThreadCommentParams
} from './NatPutBulletinBoardThreadComment'
import {NatPostBulletinBoardThreadCommentSession} from './NatPostBulletinBoardThreadCommentSession'
import {ContentType} from '../../../../network/Constants';


export default class NatBulletinBoardRepo {
    http: Http;

    constructor(http: Http) {
        this.http = http
    }

    // スレッド一覧取得(管理)
    async getAdminBulletinBoardThreadList(
        searchCondition?: AdminBulletinBoardThreadListSearchCondition,
        searchConditionPageInfo?: AdminBulletinBoardThreadListSearchConditionPageInfo,
        searchConditionSortInfos?: SortOrder[]): Promise<NatGetAdminBulletinBoardThreadList> {
        const searchParams: string[] = [];
        if (searchCondition) {
            if (searchCondition.categoryId) {
                searchParams.push(`categoryId=${encodeURIComponent(searchCondition.categoryId)}`);
            }
        }

        if (searchConditionPageInfo) {
            if (searchConditionPageInfo.pageNum) {
                searchParams.push(`pageNum=${encodeURIComponent(searchConditionPageInfo.pageNum)}`);
            }
            searchParams.push(`page=${encodeURIComponent(searchConditionPageInfo.page)}`);
        }

        if (searchConditionSortInfos) {
            searchConditionSortInfos.forEach((sortInfo) => {
                const value: string = encodeURIComponent(`${sortInfo.sortKey}:${sortInfo.sortDirection}`);
                searchParams.push(`sortInfo=${value}`)
            })
        }
        const searchParamsText: string = searchParams.join('&');

        return await this.http.get(`/api/admin/bulletinBoard/thread?${searchParamsText}`);
    }

    // スレッド一覧取得(居住者)
    async getResidentBulletinBoardThreadList(searchCondition: ResidentBulletinBoardThreadListSearchCondition
    ): Promise<NatGetResidentBulletinBoardThreadList> {

        const searchParams: string[] = [];
        searchParams.push(`categoryId=${encodeURIComponent(searchCondition.categoryId)}`);
        if (searchCondition.threadSearch) {
            searchParams.push(`threadSearch=${encodeURIComponent(searchCondition.threadSearch)}`);
        }
        const searchParamsText: string = searchParams.join('&');
        return await this.http.get(`/api/resident/bulletinBoard/thread?${searchParamsText}`);
    }

    // スレッド取得(管理)
    async getAdminBulletinBoardThread(threadId: number): Promise<NatGetAdminBulletinBoardThread> {
        return await this.http.get(`/api/admin/bulletinBoard/thread/${threadId}`);
    }

    // スレッド取得(居住者)
    async getResidentBulletinBoardThread(threadId: number): Promise<NatGetResidentBulletinBoardThread> {
        return await this.http.get(`/api/resident/bulletinBoard/thread/${threadId}`);
    }

    // コメント一覧取得(管理)
    async getAdminBulletinBoardThreadCommentList(threadId: number, queryString: string)
        : Promise<NatGetAdminBulletinBoardThreadCommentList> {
        return await this.http.get(`/api/admin/bulletinBoard/comment/${threadId}?${queryString}`);

    }

    // コメント一覧取得(居住者)
    async getResidentBulletinBoardThreadCommentList(threadId: number)
        : Promise<NatGetResidentBulletinBoardThreadCommentList> {
        return await this.http.get(`/api/resident/bulletinBoard/comment/${threadId}`);

    }

    // スレッド既読管理登録
    async postBulletinBoardThreadRead(threadId: number): Promise<NatPostBulletinBoardThreadRead> {
        return await this.http.post(`/api/common/bulletinBoard/threadAlreadyReadAdmin`, {
                threadId: threadId,
            }, ContentType.JSON,
        )
    }

    // スレッド登録
    async postBulletinBoardThread(requestParams: NatPostBulletinBoardThreadParams):
        Promise<NatPostBulletinBoardThread> {
        return await this.http.post(`/api/admin/bulletinBoard/thread`, {
                categoryId: requestParams.categoryId,
                priority: requestParams.priority,
                title: requestParams.title,
                detail: requestParams.detail,
                threadImage: requestParams.threadImage,
                threadFile: requestParams.threadFile
            }, ContentType.JSON,
        )
    }

    // スレッド登録確認
    async postBulletinBoardThreadConfirm(requestParams: NatPostBulletinBoardThreadConfirmParams):
        Promise<NatPostBulletinBoardThreadConfirm> {
        return await this.http.post(`/api/resident/bulletinBoard/thread/confirm`, {
                categoryId: requestParams.categoryId,
                priority: requestParams.priority,
                title: requestParams.title,
                detail: requestParams.detail,
                threadImage: requestParams.threadImage,
                threadFile: requestParams.threadFile
            }, ContentType.JSON,
        )
    }

    // スレッド登録（セッション）
    async postBulletinBoardThreadSession():
        Promise<NatPostBulletinBoardThreadSession> {
        return await this.http.post(`/api/resident/bulletinBoard/thread`, {}, ContentType.JSON,
        )
    }

    // スレッド更新
    async putBulletinBoardThread(threadId: number, requestParam: NatPutBulletinBoardThreadParams):
        Promise<NatPutBulletinBoardThread> {
        return await this.http.put(`/api/common/bulletinBoard/thread/${threadId}`, requestParam)
    }

    // コメント取得(管理)
    async getAdminBulletinBoardThreadComment(threadId: number, commentId: number)
        : Promise<NatGetAdminBulletinBoardThreadComment> {
        return await this.http.get(`/api/admin/bulletinBoard/comment/${threadId}/${commentId}`);

    }

    // コメント登録
    async postBulletinBoardThreadComment(requestParams: NatPostBulletinBoardThreadCommentParams):
        Promise<NatPostBulletinBoardThreadComment> {
        return await this.http.post(`/api/admin/bulletinBoard/comment/${requestParams.threadId}`, {
                comment: requestParams.comment,
                commentImage: requestParams.commentImage,
                commentFile: requestParams.commentFile
            }, ContentType.JSON,
        )
    }

    // コメント登録確認
    async postBulletinBoardThreadCommentConfirm(requestParams: NatPostBulletinBoardThreadCommentConfirmParams):
        Promise<NatPostBulletinBoardThreadCommentConfirm> {
        return await this.http.post(`/api/resident/bulletinBoard/comment/${requestParams.threadId}/confirm`, {
                threadId: requestParams.threadId,
                comment: requestParams.comment,
                commentImage: requestParams.commentImage,
                commentFile: requestParams.commentFile
            }, ContentType.JSON,
        )
    }

    // コメント登録（セッション）
    async postBulletinBoardThreadCommentSession():
        Promise<NatPostBulletinBoardThreadCommentSession> {
        return await this.http.post(`/api/resident/bulletinBoard/comment`, {}, ContentType.JSON,
        )
    }

    // コメント更新
    async putBulletinBoardThreadComment(threadId: number,
                                        commentId: number, requestParam: NatPutBulletinBoardThreadCommentParams):
        Promise<NatPutBulletinBoardThreadComment> {
        return await this.http.put(`/api/common/bulletinBoard/comment/${threadId}/${commentId}`, requestParam)
    }

}
